export default __webpack_public_path__ + "static/nestjs-8d6d5859704645e6b1d0eb4d5e281444.svg";